import React from 'react';
import PropTypes from 'prop-types';
import { MatchupStateWrapper, OutsWrapper } from '../../PlayerDuel/PlayerDuel.style';
import Outs from '@mlb/react-patterns/components/Outs/outs';
import Basepaths from '@mlb/react-patterns/components/Basepaths/basepaths';

const GameDetails = ({
    balls,
    strikes,
    outs,
    first,
    second,
    third
}) => {
    const basepaths = { first: !!first?.person, second: !!second?.person, third: !!third?.person };

    return (
        <MatchupStateWrapper $type={'singlenarrow'}>
            <Basepaths {...basepaths} width={18} />
            <span>{balls + ' - ' + strikes}</span>
            <OutsWrapper>
                <Outs outCount={outs} width={24} outSize={2} outsActiveColor={'var(--gameday-outs-color)'} outsInactiveColor='transparent' stroke />
            </OutsWrapper>
        </MatchupStateWrapper>
    );
};

GameDetails.propTypes = {
    balls: PropTypes.number,
    strikes: PropTypes.number,
    outs: PropTypes.number,
    first: PropTypes.object,
    second: PropTypes.object,
    third: PropTypes.object
};

export default GameDetails;
